@use '@bitgmbh/ebiz-patterns-core/src/fundamentals/spacings';

:host {
  --svg-size: var(--icon-size, #{spacings.$baywa-ref-space-c});

  display: grid;
  place-content: center;
  place-items: center;
}

svg {
  height: var(--svg-size);
  object-fit: contain;
  width: var(--svg-size);
}
